const MaterialIcon = ({ name, className, onClick, small, ...rest }) => {
  return (
    <span
      className={`material-symbols-outlined${className ? " " + className : ""}${
        small ? " small" : ""
      }`}
      onClick={onClick}
      {...rest}
    >
      {name}
    </span>
  );
};
export default MaterialIcon;
